// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__9SIoy","wordmark":"Navbar_wordmark__Jdnlb","accent":"Navbar_accent__DDbcY","menu-box":"Navbar_menu-box__Kvizk"};